import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import { Card, CardContent, CardDescription, CardHeader, Icon, Popup, Button } from 'semantic-ui-react';

import NewsImage from './NewsImage';
import { getUserDisplayNameFromEmail } from '../../helpers/format';

class NewsItem extends React.PureComponent {
  static propTypes = {
    newsItemObject: PropTypes.object.isRequired,
    themeType: PropTypes.string.isRequired,
    themeId: PropTypes.string.isRequired,
    getPositionTarget: PropTypes.func,
    forcedFileRef: PropTypes.string,
    // header: PropTypes.string,
  };
  static defaultProps = {
    getPositionTarget: () => null,
    forcedFileRef: null,
  }

  getTypeLabel = () => {
    switch (this.props.newsItemObject.type) {
      case 'Information':
        return (<Popup trigger={<Icon name="info circle" color="blue" />} content="Catégorie: Information" />);
      case 'Alerte':
        return (<Popup trigger={<Icon name="exclamation triangle" color="red" />} content="Catégorie: Information" />);
      default:
        return (<Popup trigger={<Icon name="question circle" />} content="Catégorie inconnue" />);
    }
  }

  getTypeColor = () => {
    switch (this.props.newsItemObject.type) {
      case 'Information':
        return 'blue';
      case 'Alerte':
        return 'red';
      default:
        return null;
    }
  }


  getShowOnMapLink = (singleLineLinks = false) => {
    const { latitude, longitude } = this.props.newsItemObject;
    const disabled = !latitude || !longitude || (latitude === '0' && longitude === '0');
    const text = disabled ? 'Message non\ngéolocalisé' : 'Afficher\nsur la carte';
    const singleLineText = disabled ? 'Non géolocalisée' : 'Afficher sur la carte';

    return (
      <Button
        size="mini"
        disabled={disabled}
        onClick={() => {
          this.passPositionToParent({ latitude, longitude });
        }}
      >
        {disabled ? null : <Icon name="marker" />}
        {singleLineLinks ? singleLineText : text}
      </Button>
    );
  }

  getFindOutMoreLink = (singleLineLinks = false) => {
    if (!this.props.newsItemObject.lien || !this.props.newsItemObject.lien.url) {
      return (null);
    }
    let icon = 'browser';
    let singleLineText = 'Plus d\'information';
    let text = 'Plus d\'information\nsur internet';
    const { url } = this.props.newsItemObject.lien;
    switch (this.props.newsItemObject.lien.type) {
      case 'facebook':
        icon = 'facebook';
        text = 'Plus d\'information\nsur Facebook';
        singleLineText = 'Plus d\'information';
        break;
      case 'twitter':
        icon = 'twitter';
        text = 'Plus d\'information\nsur Twitter';
        singleLineText = 'Plus d\'information';
        break;
      case 'phone':
        icon = 'call square';
        text = `Appeler le\n${url.substr(4)}`;
        singleLineText = url.substr(4);
        break;
      case 'mail':
        icon = 'mail';
        text = `Écrire à\n${url.substr(7)}`;
        singleLineText = url.substr(7);
        break;
      default:
        break;
    }

    return (
      <Button size="mini" as="a" href={url} target="_blank">
        <Icon name={icon} />
        {singleLineLinks ? singleLineText : text}
      </Button>
    );
  }

  getActionBlock = () =>
    // if (!this.props.newsItemObject.latitude && !this.props.newsItemObject.lien) {
    //   return null;
    // }
    (
      <CardContent>
        {this.getFindOutMoreLink()}
        {this.getShowOnMapLink()}
      </CardContent>
    )


  passPositionToParent = targetPosition => this.props.getPositionTarget(targetPosition)


  render() {
    const {
      newsItemObject, themeType, themeId, forcedFileRef,
    } = this.props;
    const date = (
      <Moment
        parse="DD/MM/YY HH:mm"
        format="DD/MM/YYYY à HH:mm"
      >
        {newsItemObject.date}
      </Moment>
    );
    // console.log(newsItemObject);
    return !!newsItemObject && (
      <Card fluid raised color={this.getTypeColor()} id={newsItemObject.key}>
        <CardContent>
          <CardHeader textAlign="left" size="small">
            {this.getTypeLabel()}
            {newsItemObject.titre ? newsItemObject.titre.toUpperCase() : null}
          </CardHeader>
          <CardDescription textAlign="left">
            Publié par {getUserDisplayNameFromEmail(newsItemObject.by)} le {date}
          </CardDescription>
        </CardContent>
        {newsItemObject && newsItemObject.image && newsItemObject.image.position === 'before'
        && <NewsImage
          newsId={forcedFileRef || newsItemObject.key}
          ext={newsItemObject.image.ext}
          forcedFileRef={forcedFileRef}
          themeType={themeType}
          themeId={themeId}
        />}
        <CardContent textAlign="left" className="whiteSpacePre">
          {newsItemObject.message}
        </CardContent>
        {newsItemObject && newsItemObject.image && newsItemObject.image.position === 'after'
        && <NewsImage
          newsId={forcedFileRef || newsItemObject.key}
          ext={newsItemObject.image.ext}
          forcedFileRef={forcedFileRef}
          themeType={themeType}
          themeId={themeId}
        />}
        {this.getActionBlock()}
      </Card>
    );
  }
}

export default NewsItem;



// WEBPACK FOOTER //
// ./src/components/News/NewsItem.js